var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticStyle:{"z-index":"999"},attrs:{"value":this.$store.getters['Drawer/GET_LOADER']}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"35"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }